import { GADS_DOWNLOAD_CONVERSION, GTAG_ID } from "./config";

// Loads gtag only when REACT_APP_GTAG_ID is set, so no third-party account is used by default.
export function initAnalytics() {
  if (!GTAG_ID || typeof document === "undefined") return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GTAG_ID);
}

export function trackDownload() {
  if (typeof window === "undefined" || !window.gtag) return;
  if (GADS_DOWNLOAD_CONVERSION) window.gtag("event", "conversion", { send_to: GADS_DOWNLOAD_CONVERSION });
  window.gtag("event", "app_download", { event_category: "engagement" });
}
